const sortByTitleAZ = (arr) => {
    arr.sort(function (a, b) {
        const titleA = a.title.toLowerCase();
        const titleB = b.title.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
    });
    return arr;
};

const sortByTitleZA = (arr) => {
    arr.sort(function (a, b) {
        const titleA = a.title.toLowerCase();
        const titleB = b.title.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
    });
    arr.reverse();
    return arr;
};

const sortLatestFirst = (arr) => {
    arr.sort(compareDateTime);
    return arr.reverse()
}

const sortOldestFirst = (arr) => {
    arr.sort(compareDateTime);
    return arr
}
const compareDateTime = (a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
  
    if (dateA < dateB) {
	  return -1;
    }
    if (dateA > dateB) {
	  return 1;
    }
    return 0;
};

const isSolidColorImage = async (imageUrl, threshold = 80) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const totalPixels = data.length / 4;

      const colorCountMap = new Map();

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];

        const colorKey = `${r},${g},${b},${a}`;
        colorCountMap.set(colorKey, (colorCountMap.get(colorKey) || 0) + 1);
      }

      // Find the most common color
      for (const [colorKey, count] of colorCountMap.entries()) {
        const percent = (count / totalPixels) * 100;
        if (percent >= threshold) {
          const [r, g, b] = colorKey.split(',').map(Number);

          // Calculate brightness using YIQ formula
          const brightness = (r * 299 + g * 587 + b * 114) / 1000;
          const isLight = brightness >= 128;

          return resolve({
            isSolidColor: true,
            isLight,
            color: colorKey,
          });
        }
      }

      resolve({
        isSolidColor: false,
        isLight: false,
        color: null,
      });
    };

    img.onerror = () => {
      reject(new Error("Image failed to load or isn't accessible"));
    };

    img.src = imageUrl;
  });
};

const splitArr = (array, addedCountInRightSide) => {
  const total = array.length;
  const mid = Math.floor(total / 2);

  // Ensure addedCountInRightSide doesn't push right beyond array length
  const rightStartIndex = mid + addedCountInRightSide;

  const leftSideData = array.slice(0, rightStartIndex);
  const rightSideData = array.slice(rightStartIndex);

  return [leftSideData, rightSideData];
};

function prioritizeItemsByKey(items, keyValuesToPrioritize = [], key = 'id') {
  if (!Array.isArray(items) || items.length === 0) return items;
  const keyExists = items.some(item => key in item);
  if (!keyExists) return items;

  const itemMap = new Map(items.map(item => [item[key], item]));
  const prioritized = keyValuesToPrioritize
    .map(value => itemMap.get(value))
    .filter(Boolean);

  const prioritizedSet = new Set(keyValuesToPrioritize);
  const remaining = items.filter(item => !prioritizedSet.has(item[key]));

  return [...prioritized, ...remaining];
}

const isPdfUrl = (url) => {
  if (!url) return false;
  const urlLower = url.toLowerCase();
  return urlLower.includes('.pdf') || urlLower.includes('pdf');
};

module.exports = {isPdfUrl, sortByTitleAZ, sortByTitleZA, sortLatestFirst, sortOldestFirst, isSolidColorImage, splitArr , prioritizeItemsByKey};
